import {API_BASE_URL} from 'configs'; // eslint-disable-line import/no-unresolved
import axios from 'axios';

function createHttp() {
  return axios.create({
    baseURL: API_BASE_URL,
    withCredentials: process.env.NODE_ENV !== 'production',
  });
}

export default {
  get(url, params) {
    return createHttp().get(url, {params});
  },

  post(url, data) {
    return createHttp().post(url, data);
  },

  put(url, data) {
    return createHttp().put(url, data);
  },

  delete(url, params) {
    return createHttp().delete(url, {params});
  },
};



// WEBPACK FOOTER //
// ./app/features/shared/services/http.js